export default {
  name: 'st-select',
  inheritAttrs: false,
  props: {
    menuProps: Object
  },
  computed: {
    resolvedMenuProps () {
      return Object.assign({ offsetY: true }, this.menuProps || {})
    }
  }
}
